import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const migrateCheckoutExperienceToConstraintsV2 = {
  name: "migrateCheckoutExperienceToConstraintsV2" as const,
  input: z.object({ checkoutExperienceId: zExt.objectId() }),
  output: z.null(),
};
